import { useQuery } from '@tanstack/react-query'
import { searchDomains } from '../../services'
import { AdminQueryKey } from '@/modules/admin/keys'
import {
	SearchDomainsRequest,
	SearchDomainsResponse,
} from '@/modules/admin/type'

export default function useQuerySearchDomains(
	payload: SearchDomainsRequest,
	enabled: boolean,
) {
	return useQuery<SearchDomainsResponse>({
		queryKey: [AdminQueryKey.SearchDomains, payload],
		queryFn: () => searchDomains(payload),
		enabled,
	})
}
